import React, { useMemo } from "react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseIcon from "@mui/icons-material/Close";
import "./styles.css"


export const InsutryPartsTableHeader = ({ header, name, handleChanges, handleSelect, placeholder, handleSortClick, items = [], inputValue = "", selectedValue = "", formatValue }) => {

  const distinctValues = useMemo(() => {
    const getValue = (item) => (formatValue ? formatValue(name, item) : item?.[name]);
    const values = items
      .map(getValue)
      .filter((value) => {
        if (value === null || value === undefined || value === "") return false;
        const type = typeof value;
        return type === "string" || type === "number" || type === "boolean";
      })
      .map((value) => value.toString());

    return [...new Set(values)].sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
  }, [items, name, formatValue]);

  const handleSelectValue = (value) => {
    const handler = handleSelect || handleChanges;
    handler({ target: { name, value } });
  };

  return (
    <th className="cursor">
      <ul className="navbar-nav">
        <li className="dropdown">
          <a className={`dropdown-toggle${inputValue || selectedValue ? " dropdown-toggle--filtered" : ""}`} data-bs-toggle="dropdown">
            {header}
            {(inputValue || selectedValue) && (
              <FilterAltIcon className="dropdown-toggle__filter-icon" fontSize="small" />
            )}
          </a>
          <ul className="dropdown-menu p-3" aria-labelledby="navbarDarkDropdownMenuLink">
            <li className="pb-3">
              <div className="filter-input-row">
                <input placeholder={placeholder} name={name} value={inputValue} onChange={handleChanges}/>
                <button
                  type="button"
                  className="filter-icon-btn"
                  title="Limpar texto"
                  onClick={(e) => { e.stopPropagation(); handleChanges({ target: { name, value: "" } }); }}
                >
                  <CloseIcon fontSize="small" />
                </button>
              </div>
            </li>
            <li>
              <button
                className="btn btn-outline-dark w-100 p-0"
                onClick={() => handleSortClick(name)}
              >
                Ordenar A - Z
              </button>
            </li>
            {distinctValues.length > 0 && (
              <li className="distinct-values-list mt-2">
                {distinctValues.map((value, index) => (
                  <button
                    type="button"
                    key={`distinct-${name}-${index}`}
                    className={`distinct-value-item${selectedValue === value ? " distinct-value-item--selected" : ""}`}
                    onClick={() => handleSelectValue(value)}
                  >
                    {value}
                  </button>
                ))}
              </li>
            )}
            <li className="filter-footer mt-2">
              <button
                type="button"
                className="btn btn-primary w-100"
                onClick={(e) => {
                  const li = e.currentTarget.closest(".dropdown");
                  const toggle = li?.querySelector('[data-bs-toggle="dropdown"]');
                  if (toggle) toggle.click();
                }}
              >
                Ok
              </button>
            </li>
          </ul>
        </li>
      </ul>
    </th>
  );
}
